import React from "react";
import Dropzone from "react-dropzone";
import ProductImage from "models/ProductImage";
import ImageHelper from "helpers/Image";

export default class MultiImageView extends React.Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = { init: 0, error: null, files: props.files };
    this.dragStartIndex = -1;
    this.dragEndIndex = -1;
    this.imageToDrag = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDirty === true && this.props.isDirty === false) {
      this.setState({ files: this.props.files });
    }
  }

  onClickEvent = (event) => {
    this.inputFile.current.click();
  };

  setDragging = (ev) => {
    ev.preventDefault();
    this.dragStartIndex = ev.currentTarget.dataset.index;
  };

  dragOverHandler = (ev) => {
    ev.preventDefault();
    if (this.dragStartIndex != ev.currentTarget.dataset.index) {
      ev.dataTransfer.dropEffect = "copy";
    }
    this.dragEndIndex = ev.currentTarget.dataset.index;
    return false;
  };

  dragLeaveHandler = (ev) => {
    ev.preventDefault();
    this.dragEndIndex = -1;
  };

  dropHandler = (ev) => {
    const { files } = this.state;

    if (this.dragStartIndex == this.dragEndIndex || this.dragEndIndex == -1) {
      this.imageToDrag.draggable = false;
      return;
    }
    var fileToDrag = files[this.dragStartIndex];
    files.splice(this.dragStartIndex, 1);
    files.splice(this.dragEndIndex, 0, fileToDrag);
    this.setState({ files: files });
    const { onChange } = this.props;
    if (onChange) {
      onChange(files);
    }
  };

  removeImageHandler = (ev) => {
    const { files } = this.state;
    const { onChange } = this.props;
    ev.preventDefault();
    let removeIndex = ev.currentTarget.dataset.index;
    files[removeIndex].removeImage();
    if (files[removeIndex].id == 0) {
      files.splice(removeIndex, 1);
    }
    this.setState({ files: files });
    if (onChange) {
      onChange(files);
    }
  };

  onStartDragHandler = (ev) => {
    this.imageToDrag = ev.currentTarget.closest("[draggable]");
    this.imageToDrag.draggable = true;
  };

  async onChangeFile(event) {
    event.stopPropagation();
    event.preventDefault();

    let file = event.target.files[0];
    let orgFile = file;

    const reader = new FileReader();
    reader.onloadend = async () => {
      let newImage = await ImageHelper.resizeImage(
        file,
        reader.result,
        800,
        800
      );
      const { files } = this.state;
      var productImg = new ProductImage();
      productImg.newImage(newImage);
      files.push(productImg);
      this.setState({ files: files });
      const { onChange } = this.props;
      if (onChange) {
        onChange(files);
      }
    };
    reader.readAsDataURL(file);
  }

  renderUploadButton() {
    let { extraClass } = this.props;

    return (
      <div className="w-full" key="-1">
        <div
          className="flex justify-center items-center p-4 border-2 border-gray-300 border-dashed transition-colors duration-200 cursor-pointer aspect-square hover:border-primary group"
          onClick={this.onClickEvent}
        >
          <div className="text-center">
            <div className="flex justify-center items-center mx-auto w-12 h-12 rounded-full transition-colors duration-200 bg-primary/5 group-hover:bg-primary/20">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-primary"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 4V12M12 12V20M12 12H4M12 12H20"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div className="mt-3 text-sm font-medium text-gray-900 transition-colors duration-200 group-hover:text-primary">
              Upload afbeelding
            </div>
            <p className="mt-1 text-xs text-gray-500">PNG, JPG tot 10MB</p>
            <input
              type="file"
              className="hidden"
              ref={this.inputFile}
              onChange={this.onChangeFile.bind(this)}
              accept="image/*"
            />
          </div>
        </div>
      </div>
    );
  }

  renderImageElement(imageModel, index) {
    return (
      <div className="w-full" key={index}>
        <div
          className="overflow-hidden relative border border-gray-300 aspect-square group"
          data-index={index}
          draggable="false"
          onDrag={this.setDragging}
          onDragOver={this.dragOverHandler}
          onDragLeave={this.dragLeaveHandler}
          onDragEnd={this.dropHandler}
        >
          <img
            src={imageModel.getImage()}
            className="object-cover w-full h-full"
            alt="Product image"
          />

          {/* Overlay with actions */}
          <div className="flex absolute inset-0 justify-center items-center bg-black bg-opacity-50 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
            <div className="flex space-x-3">
              {/* Move/Drag handle */}
              <button
                type="button"
                className="p-2 text-white bg-white bg-opacity-20 rounded-full transition-all duration-200 hover:bg-opacity-30 focus:outline-none"
                onMouseDown={this.onStartDragHandler}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {/* Delete button */}
              <button
                type="button"
                className="p-2 text-white bg-red-500 bg-opacity-80 rounded-full transition-all duration-200 hover:bg-opacity-100 focus:outline-none"
                onClick={this.removeImageHandler}
                data-index={index}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { files } = this.state;

    var returnHtml = [this.renderUploadButton()];
    if (Array.isArray(files) && files.length > 0) {
      for (let i in files) {
        if (files[i].remove == 0) {
          returnHtml.push(this.renderImageElement(files[i], i));
        }
      }
    }

    return returnHtml;
  }
}

MultiImageView.defaultProps = {
  files: [],
  extraClass: "",
};
